import type { ProgressProps, ProgressStyle } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import {
  CheckboxField,
  ColorField,
  NumberField,
  SelectField,
  TextField,
} from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const STYLE = ["linear", "striped", "rounded"] as const;

export function ProgressInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as ProgressProps;

  return (
    <>
      <TextField
        label="Label"
        value={p.label ?? ""}
        onChange={(v) => update(widget.id, { label: v || undefined })}
      />
      <div className="emke-inspector-grid-2" style={{ padding: "0 16px" }}>
        <NumberField
          label="Value"
          value={p.value}
          min={0}
          max={100000}
          onChange={(v) => update(widget.id, { value: v })}
        />
        <NumberField
          label="Max"
          value={p.max ?? 100}
          min={1}
          max={100000}
          onChange={(v) => update(widget.id, { max: v })}
        />
      </div>
      <SelectField
        label="Style"
        value={p.style ?? "rounded"}
        options={STYLE}
        onChange={(v) => update(widget.id, { style: v as ProgressStyle })}
      />
      <NumberField
        label="Height (px)"
        value={p.height ?? 10}
        min={2}
        max={60}
        onChange={(v) => update(widget.id, { height: v })}
      />
      <CheckboxField
        label="Show percentage"
        value={p.showValue ?? true}
        onChange={(v) => update(widget.id, { showValue: v })}
      />
      <ColorField
        label="Fill colour"
        value={p.fillColor ?? "#111827"}
        onChange={(v) => update(widget.id, { fillColor: v })}
      />
      <ColorField
        label="Track colour"
        value={p.trackColor ?? "#e5e7eb"}
        onChange={(v) => update(widget.id, { trackColor: v })}
      />
    </>
  );
}
